/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface RefreshTokenResponseDto
 */
export interface RefreshTokenResponseDto {

    /**
     * @type {string}
     * @memberof RefreshTokenResponseDto
     */
    accessToken: string;

    /**
     * @type {string}
     * @memberof RefreshTokenResponseDto
     */
    refreshToken: string;

    /**
     * @type {number}
     * @memberof RefreshTokenResponseDto
     */
    expireIn: number;

    /**
     * @type {number}
     * @memberof RefreshTokenResponseDto
     */
    refreshTokenExpireIn: number;

    /**
     * @type {any}
     * @memberof RefreshTokenResponseDto
     */
    tokenType: any;
}
